import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { ChangeLogType, EmailLogType } from "../types/genericType";

export const getEmailLogs = async (): Promise<EmailLogType[]> => {
  try {
    const response: AxiosResponse<EmailLogType[]> = await axiosInstance.get(
      `${apiEndPoints.emailLogs}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getChangeLogs = async (): Promise<ChangeLogType[]> => {
  try {
    const response: AxiosResponse<ChangeLogType[]> = await axiosInstance.get(
      `${apiEndPoints.auditLogs}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
